import { FormattedMessage } from 'react-intl';
import PlusIcon from '~/components/atoms/icon/plus/PlusIcon';
import { SectionHeading } from '~/components/molecules/heading/SectionHeading';
import Category from '~/components/organisms/category/category';
import { MobileLayout_S } from '~/core/configuration/configuration-global-config.schema';
import { useSERPActions } from '~/core/state/actions/SERPActionsContext';
import { useSERPState } from '~/core/state/SERPStateContext';
import { LoadMore } from '~/core/useSearchState';
import { UseCategoryResultsItem } from '~/hooks/useCategoryResults';
import { useSelectedTab } from '~/hooks/useSelectedTab';
import { useShouldRenderSet } from '~/hooks/useShouldRenderSet';
import styles from './categories.module.scss';

interface CategoryListProps {
    categoryResult: UseCategoryResultsItem;
    loadMore: LoadMore;
}

export const CategoryList = ({ categoryResult, loadMore }: CategoryListProps) => {
    const shouldRenderOnMobile = useShouldRenderSet({ identifier: categoryResult.result.querySetIdentifier });
    const result = categoryResult.result;
    const { handleGoToResult } = useSERPActions();
    const { activeTab } = useSelectedTab();
    const { config } = useSERPState();

    const isNotInTabs = config.mobileLayout !== MobileLayout_S.Values.tabs;

    if (!shouldRenderOnMobile) {
        return null;
    }

    return (
        <div
            className={styles.categories}
            key={result.querySetIdentifier}
            id={`tabpanel-${activeTab?.title}`}
            role="tabpanel"
            aria-labelledby={`tab-${activeTab?.title}`}
        >
            <SectionHeading text={categoryResult.title} />
            <ul className={`${styles.categoriesList} ${isNotInTabs ? styles.notInTabs : ''}`}>
                {result.hits.map((hit, index) => {
                    return (
                        <Category
                            key={`${hit.title}-${hit.url}`}
                            result={hit}
                            order={index + 1}
                            handleGoToResult={handleGoToResult}
                        />
                    );
                })}
                {result.hits.length < result.totalRecords ? (
                    <li className={styles.categoriesButton}>
                        <button
                            onClick={() =>
                                loadMore({
                                    querySetIdentifier: result.querySetIdentifier,
                                    from: result.hits.length,
                                })
                            }
                            className={styles.categoriesLoadButton}
                            data-testid="categories-load-more-input"
                        >
                            <PlusIcon fill="currentColor" />
                            <FormattedMessage id="load_more_categories" defaultMessage="Načíst další kategorie" />
                        </button>
                    </li>
                ) : null}
            </ul>
        </div>
    );
};
